import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=cc6e2b14&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=ts"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=cc6e2b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6e2b14",
  null
  
)

export default component.exports